import React, {Component} from "react";
import DirectionBtn from "../../Buttons/DirectionBtn";

class CalendarTopMenu extends Component {
    state = {
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
        back: false,
    }

    onPrev = () => {
        let {year, month} = this.state;
        month--;
        if (month < 0) {
            month = 11;
            year--;
        }

        this.setState({
            year: year,
            month: month
        });

        this.props.onPrev(year, month);
    }

    onNext = () => {
        let {year, month} = this.state;
        month++;
        if (month > 11) {
            month = 0;
            year++;
        }

        this.setState({
            year: year,
            month: month
        });
        this.props.onNext(year, month);
    }

    render() {
        const {year, month} = this.state;
        return (
            <div className="mainTopMenu">
                <div className="dateWrapper">
	                <span className="today">
	                    {year}년 {month + 1}월
	                </span>
                    <div className="btnWrapper">
                        <DirectionBtn btnName="prev" click={this.onPrev} size="small"/>
                        <DirectionBtn btnName="next" click={this.onNext} size="small"/>
                    </div>
                    <div className="month">{month + 1}월</div>
                </div>
            </div>
        );
    }
}

CalendarTopMenu.defaultProps = {
    onPrev: () => {
    },
    onNext: () => {
    }
}
export default CalendarTopMenu;


// WEBPACK FOOTER //
// ./src/components/Containers/CalendarTopMenu/index.js